/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class ReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getReports({
    metric,
    from,
    to,
    type = 'account',
    id,
    groupBy,
    businessHours,
  }) {
    return axios.get(`${this.url}`, {
      params: {
        metric,
        since: from,
        until: to,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // eslint-disable-next-line default-param-last
  getSummary(since, until, type = 'account', id, groupBy, businessHours) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getConversationMetric(type = 'account', page = 1) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        type,
        page,
      },
    });
  }

  getAgentReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/agents`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getConversationTrafficCSV({ daysBefore = 6 } = {}) {
    return axios.get(`${this.url}/conversation_traffic`, {
      params: { timezone_offset: getTimeOffset(), days_before: daysBefore },
    });
  }

  getLabelReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/labels`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getInboxReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/inboxes`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getTeamReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/teams`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getBotMetrics({ from, to } = {}) {
    return axios.get(`${this.url}/bot_metrics`, {
      params: { since: from, until: to },
    });
  }

  getBotSummary({ from, to, inboxIds, businessHours } = {}) {
    return axios.get(`${this.url}/bot_summary`, {
      params: {
        since: from,
        until: to,
        inbox_ids: inboxIds,
        business_hours: businessHours,
      },
    });
  }

  getBotTimeseries({ from, to, inboxIds, businessHours, groupBy } = {}) {
    return axios.get(`${this.url}/bot_timeseries`, {
      params: {
        since: from,
        until: to,
        inbox_ids: inboxIds,
        business_hours: businessHours,
        group_by: groupBy,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getClassificationReports({
    from,
    to,
    inboxIds,
    businessHours,
    page,
    perPage,
  }) {
    return axios.get(`${this.url}/classifications`, {
      params: {
        since: from,
        until: to,
        inbox_ids: inboxIds,
        business_hours: businessHours,
        page: page || 1,
        per_page: perPage || 25,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getQueuesAgentsReport({ from, to, inboxIds, businessHours }) {
    return axios.get(`${this.url}/queues_agents`, {
      params: {
        since: from,
        until: to,
        inbox_ids: inboxIds,
        business_hours: businessHours,
      },
    });
  }

  downloadClassificationReports({ from, to, inboxIds, businessHours }) {
    return axios.get(`${this.url}/classifications_download`, {
      params: {
        since: from,
        until: to,
        inbox_ids: inboxIds,
        business_hours: businessHours,
      },
    });
  }

  downloadQueuesAgentsReport({ from, to, inboxIds, businessHours }) {
    return axios.get(`${this.url}/queues_agents_download`, {
      params: {
        since: from,
        until: to,
        inbox_ids: inboxIds,
        business_hours: businessHours,
      },
    });
  }
}

export default new ReportsAPI();
